/**
 * No domain event for this long → `live` becomes false.
 * Pong/connected do not prove the event bus; they only prove TCP is up.
 */
export const REALTIME_LIVE_STALE_MS = 50_000;
